// @ts-strict-ignore
import React from 'react'
import { render } from '@testing-library/react'
import i18n from 'i18next'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import mockEngTranslation from '../src/assets/locales/en/translation.json'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translations'],
  defaultNS: 'translations',
  debug: false,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
  resources: { en: { translations: mockEngTranslation } },
})
export default i18n

export const getTranslation = (translation: string, variables?: {}): string =>
  i18n.t(translation, variables)

export const renderWithI18next = (
  ui: React.ReactNode,
  wrapper?: React.JSXElementConstructor<{ children: React.ReactNode }>
) => {
  return render(<I18nextProvider i18n={i18n}>{ui}</I18nextProvider>, { wrapper })
}

export const wrapperI18next = ({ children }) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
